import { css } from 'styled-components';
import * as base from './base';
import * as darkTheme from '../generated/themes/dark-theme';

export const cssVariables = css`
  ${base.cssVariables}

  ${darkTheme.cssVariables}
`;

export const theme = {
  ...base.theme,
  ...darkTheme.theme,
};
